<template>
  <div class="match-criteria-overview-container">
    <v-expansion-panels>
      <v-expansion-panel
        v-for="(deal, index) in deals"
        :key="`deal-item-${index}`"
        class="deal-details-container expand-panel ma-0"
        @click="selectedDeal = index"
      >
        <v-expansion-panel-header
          :hide-actions="true"
          class="match-row-header"
        >
          <template #default="{ open }">
            <h3>
              Matched on: {{ deal.createdAt | date }}
            </h3>
            <v-icon class="drop-down-icon" :class="{ open }">
              mdi-menu-right
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <h2 class="results-title">Results:</h2>
          <v-row v-if="matchedWithLenders(index)">
            <v-col
              v-for="match in deal.matches"
              :key="'lender-' + match.id"
              cols="12"
            >
              <lender-card
                :lender="match.product"
                :match="match"
                :dealId="deal.id"
                :alignDetails="'between'"
              ></lender-card>
            </v-col>
          </v-row>
          <v-row v-else>
            <p>
              There are no lenders that match your criteria. This could be do to regulatory issues, credit score or other varying factors. <strong>Although, we were unable to get an exact match to one of our lenders, we encourage you to reach out to one of our top rated lending partners to review your situation.</strong>
            </p>

            <h2 v-if="deal.matches.length">
              Featured lenders:
            </h2>

            <v-col
              v-for="match in deal.matches"
              :key="'lender-' + match.id"
              cols="12"
            >
              <lender-card
                :lender="match.product"
                :match="match"
                :dealId="deal.id"
                :alignDetails="'between'"
              ></lender-card>
            </v-col>
          </v-row>

          <v-expansion-panels flat accordian hover>
            <v-expansion-panel class="nested-panel">
              <v-expansion-panel-header>
                <h3>How did I get these results?</h3>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <DealDetailsSection :deal="deal" />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import DealDetailsSection from './DealDetailsSection'

import LenderCard from './LenderCard'

export default {
  name: 'UserDealsList',
  components: {
    LenderCard,
    DealDetailsSection,
  },
  props: {
    deals: Array,
  },
  data: () => ({
    selectedDeal: null,
    dealRemoveDialog: false,
    selectedItem: {},
  }),
  methods: {
    matchedWithLenders (dealIndex) {
      return (
        (this.deals[dealIndex].matches || []).length &&
        this.deals[dealIndex].matches.every(({ featured }) => !featured)
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.match-criteria-overview-container {
  background-color: #f7f7f7;

  .table-title {
    font-family: "Sansation Bold", Serif;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0.43px;
    color: #4e4e4e;
    margin: 47px 0 42px 0;
    padding: 0 88px;
  }

  .expand-panel {
    border-radius: 0 !important;
  }

  .deal-details-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .match-row-header {
      padding: 0 10%;

      display: flex;
      align-items: center;

      background-color: $secondaryBlue;
      color: white;

      &.v-expansion-panel-header--active {
        background-color: $primaryBlue;
      }

      h3 {
        font-family: "Sansation Regular", sans-serif;
        font-weight: normal;
      }

      & > * {
        flex: 0 1 auto;
      }

      .v-icon {
        color: inherit;
        font-size: 30px;

        transition-duration: 0.5s;
        &.open { transform: rotate(90deg); }
      }
    }

    &:not(:last-of-type) .match-row-header {
      border-bottom: 1px solid white;
    }

    .panel-content {
      width: 85%;
      padding-top: 40px;
      padding-bottom: 20px;
    }

    .panel-content {
      padding-top: 30px;
      padding-bottom: 10px;
    }

    .nested-panel {
      margin-top: 20px;

      .v-expansion-panel-header {
        width: fit-content;
        max-width: 100%;

        color: $accentBlue;

        .v-expansion-panel-header__icon .v-icon {
          color: $accentBlue;
          font-size: 32px;
        }
      }

      .v-expansion-panel-content {
        width: 100%;
      }
    }
  }
}

h2 {
  margin-bottom: 10px;
  color: $textDarkMuted;
}

::v-deep {
  .v-expansion-panel-content__wrap {
    padding: 0;
  }
}
</style>
